import { WarningBox } from "pages/Sikring/components/InfoBox";
import { Month, WARN_SHARE_OF_EXPECTED_CONSUMPTION, checkVolumeAgainstConsumption, formatNumber, fmtPercent, isDefined } from "pages/Sikring/sikringUtils";
import { SikringMaalepunkt } from "pages/Sikring/types";

interface HighVolumeWarningProps {
	volumKwh: number | null;
	months: Month[];
	meteringPoints: SikringMaalepunkt[];
}

/** Bare et varsel - et høyt volum stopper ikke veiviseren. */
export function HighVolumeWarning({ volumKwh, months, meteringPoints }: Readonly<HighVolumeWarningProps>) {
	const missingCount = meteringPoints.filter((mp) => !isDefined(mp.forventetAarsforbrukKwh)).length;
	if (missingCount > 0 && isDefined(volumKwh) && volumKwh > 0) {
		return (
			<WarningBox
				heading="Volumet kunne ikke sjekkes mot kundens forbruk."
				body={`${missingCount} av ${meteringPoints.length} målepunkt mangler forventet årsforbruk.`}
			/>
		);
	}

	const check = checkVolumeAgainstConsumption(volumKwh, months, meteringPoints);
	if (!check || check.share <= WARN_SHARE_OF_EXPECTED_CONSUMPTION) return null;

	return (
		<WarningBox
			tone="orange"
			heading={`Volumet er ${fmtPercent(check.share * 100)} av kundens forventede forbruk.`}
			body={`Forventet forbruk i perioden er ${formatNumber(Math.round(check.expectedKwh))} kWh. Sikringer over ${fmtPercent(WARN_SHARE_OF_EXPECTED_CONSUMPTION * 100)} av forbruket bør dobbeltsjekkes.`}
		/>
	);
}
